import * as React from "react";
import  "./styles/FloatingTitle.scss";

import {Bundle, PokerItem} from "../http/protocol";
import {t} from "../i18n";


interface Props {
    bundle: Bundle;
    item?: PokerItem;
}

const CategoryComponent = (props: {category: string}) => {
    return (
        <span className={"avatarOrTicket"}>
            {
                t(`store.bundles.${props.category}`)
            }
        </span>
    )
}


const FloatingTitle: React.FC<Props> = ({bundle, item}) => {
    return (
        <div className={"floatingTitle"}>
            <span className={"title"}>
                {
                    bundle&& bundle.name&& bundle.name
                }
            </span>
            {
                item&&item.category&& (
                    <CategoryComponent category={item.category}/>
                )
            }
        </div>
    )
}

export default FloatingTitle;

